module.exports = __webpack_public_path__ + "img/DC-Logo-Web-White-StackedTagline.dfb56e3.png";